import { AllyAccessibility, AllyAngular } from "../libraries";
import { AllyBase } from "./base";

/**
 * This class provides the class found under ../libraries/
 * 
 * @extends AllyBase
 */
export class AllyLibrary extends AllyBase {
    /**
     * This AllyLibary objects AllyAngular object.
     * 
     * @see AllyAngular
     */
    public angular: AllyAngular;
    /**
     * This AllyLibary objects AllyAccessibility object.
     * 
     * @see AllyAccessibility
     */
    public a11y: AllyAccessibility;
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge);
        this.angular = new AllyAngular(this.bridge);
        this.a11y = new AllyAccessibility(this.bridge);
    }
}